import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import "../src/design/app.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import store from "@/state/store";
import App from "./App.vue";
import Multiselect from "vue-multiselect";
import tinymce from "vue-tinymce-editor";
import excel from "vue-excel-export";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueQRCodeComponent from "vue-qrcode-component";
import VueSpeedMeter from "vue-speed-meter";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.component("qr-code", VueQRCodeComponent);
Vue.component("tinymce", tinymce);
Vue.component("vue-speed-meter", VueSpeedMeter);
Vue.use(VueQuillEditor);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(excel);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Toast, {
    position: "top-right",
    timeout: 4000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    hideProgressBar: false,
    newestOnTop: true,
});
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.component("multiselect", Multiselect);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.component("apexchart", VueApexCharts);
Vue.component("v-select", vSelect);

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
